import { render } from "./StudentCard.vue?vue&type=template&id=bb3cd6f0&scoped=true"
import script from "./StudentCard.vue?vue&type=script&lang=js"
export * from "./StudentCard.vue?vue&type=script&lang=js"

import "./StudentCard.vue?vue&type=style&index=0&id=bb3cd6f0&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb3cd6f0"]])

export default __exports__